import flatten from 'lodash/flatten';

export default function hasValidCoordinates(geometry: GeoJSON.Geometry) {
    if (!geometry || !geometry.type || !(geometry as any).coordinates) return false;

    let flatCoords = [];
    if (geometry.type === 'Point') {
        flatCoords = [geometry.coordinates];
    } else if (geometry.type === 'LineString') {
        flatCoords = geometry.coordinates;
    } else if (geometry.type === 'Polygon') {
        flatCoords = flatten(geometry.coordinates);
    } else {
        throw Error('Geometry type not supported by hasValidCoordinates');
    }

    for (let i = 0; i < flatCoords.length; i++) {
        if (flatCoords[i].length < 2) {
            return false;
        }
        if (
            flatCoords[i][0] < -180 ||
            flatCoords[i][0] > 180 ||
            flatCoords[i][1] < -90 ||
            flatCoords[i][1] > 90
        ) {
            return false;
        }
    }
    return true;
}
